import { Skeleton } from "@/components/ui/skeleton";

export const BudgetDisplaySkeleton = () => {
  return (
    <div className="rounded-2xl border-2 border-border bg-card overflow-hidden">
      {/* Primary Focus: Daily Safe-to-Spend */}
      <div className="px-6 pt-8 pb-6 text-center">
        <Skeleton className="h-4 w-32 mx-auto mb-4" />
        
        {/* THE ONE BIG NUMBER */}
        <Skeleton className="h-16 w-48 mx-auto mb-2" />
      </div>

      {/* Progress Bar */}
      <div className="px-6 pb-4">
        <Skeleton className="h-3 w-full rounded-full" />
        <Skeleton className="h-4 w-32 mx-auto mt-2" />
      </div>

      {/* Spent / Budget */}
      <div className="px-6 pb-4 flex items-center justify-center gap-2">
        <Skeleton className="h-4 w-16" />
        <Skeleton className="h-4 w-20" />
        <Skeleton className="h-4 w-4" />
        <Skeleton className="h-4 w-20" />
      </div>

      {/* See Details */}
      <div className="py-3 px-6 flex items-center justify-center border-t">
        <Skeleton className="h-4 w-24" />
      </div>
    </div>
  );
};

export const BudgetDisplayMinimizedSkeleton = () => {
  return (
    <div className="sticky top-0 z-10 bg-card border-b border-border px-4 py-4">
      <div className="flex items-center justify-between max-w-2xl mx-auto">
        <div className="space-y-2">
          <Skeleton className="h-4 w-24" />
          <Skeleton className="h-8 w-32" />
        </div>
        <Skeleton className="h-5 w-5" />
      </div>
    </div>
  );
};
